// src/payments.ts
var InvestmentPaymentCategory = /* @__PURE__ */ ((InvestmentPaymentCategory2) => {
  InvestmentPaymentCategory2["STRIPE"] = "STRIPE";
  InvestmentPaymentCategory2["MANUAL"] = "MANUAL";
  InvestmentPaymentCategory2["CRYPTO"] = "CRYPTO";
  InvestmentPaymentCategory2["ADJUSTMENT"] = "ADJUSTMENT";
  return InvestmentPaymentCategory2;
})(InvestmentPaymentCategory || {});
var FeePayer = /* @__PURE__ */ ((FeePayer2) => {
  FeePayer2["ISSUER"] = "ISSUER";
  FeePayer2["INVESTOR"] = "INVESTOR";
  return FeePayer2;
})(FeePayer || {});
var PayoutProvider = /* @__PURE__ */ ((PayoutProvider2) => {
  PayoutProvider2["STRIPE"] = "STRIPE";
  PayoutProvider2["CRYPTO"] = "CRYPTO";
  return PayoutProvider2;
})(PayoutProvider || {});
var PAYMENT_STATUSES = {
  SUCCEEDED: "succeeded",
  CREATED: "created",
  PENDING: "pending",
  // Crypto/BVNK-only
  PROCESSING: "processing",
  REQUIRES_CAPTURE: "requires_capture",
  REQUIRES_ACTION: "requires_action",
  REQUIRES_PAYMENT_METHOD: "requires_payment_method",
  CANCELED: "canceled",
  REFUNDED: "refunded",
  DETECTED: "detected",
  UNDERPAID: "underpaid",
  EXPIRED: "expired"
};
var PAYMENT_PENDING_STATUSES = [
  PAYMENT_STATUSES.CREATED,
  PAYMENT_STATUSES.PROCESSING,
  PAYMENT_STATUSES.REQUIRES_ACTION,
  PAYMENT_STATUSES.REQUIRES_CAPTURE,
  PAYMENT_STATUSES.REQUIRES_PAYMENT_METHOD,
  PAYMENT_STATUSES.UNDERPAID,
  PAYMENT_STATUSES.DETECTED
];
var PAYMENT_FAILED_STATUSES = [
  PAYMENT_STATUSES.CANCELED,
  PAYMENT_STATUSES.EXPIRED,
  PAYMENT_STATUSES.REQUIRES_PAYMENT_METHOD
];
var PAYMENTS_CHANGE_METHOD_STATUSES = [
  ...PAYMENT_FAILED_STATUSES,
  PAYMENT_STATUSES.CREATED,
  PAYMENT_STATUSES.PENDING
];
var PAYMENT_STRIKETHROUGH_AMOUNT_STATUSES = [...PAYMENT_FAILED_STATUSES, PAYMENT_STATUSES.REFUNDED];
var STRIPE_WIRE_PRINT_STORAGE_PREFIX = "stripe-wire-print:";
var MAX_PAYMENT_AMOUNT = 15e6;
export {
  FeePayer,
  InvestmentPaymentCategory,
  MAX_PAYMENT_AMOUNT,
  PAYMENTS_CHANGE_METHOD_STATUSES,
  PAYMENT_FAILED_STATUSES,
  PAYMENT_PENDING_STATUSES,
  PAYMENT_STATUSES,
  PAYMENT_STRIKETHROUGH_AMOUNT_STATUSES,
  PayoutProvider,
  STRIPE_WIRE_PRINT_STORAGE_PREFIX
};
//# sourceMappingURL=payments.mjs.map